export type ConversationRecipientParticipant = {
  id?: string | number | null;
  role?: string | null; // legacy UI uses `role`
  kind?: string | null; // Agent Service uses `kind`
};

export type ConversationWithParticipants = {
  participants?: ConversationRecipientParticipant[] | null;
};

export const getPrimaryConversationUserId = (
  conversation: ConversationWithParticipants | null | undefined
): string | null => {
  const participants = conversation?.participants;
  if (!participants || participants.length === 0) return null;

  const userParticipant = participants.find((p) => {
    const kind = (p as any)?.kind;
    const role = (p as any)?.role;
    return kind === 'user' || role === 'user' || role === 'human';
  });

  const userId = userParticipant?.id;
  if (userId == null) return null;
  return String(userId);
};


